import * as Sentry from '@sentry/react'

import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router'

Sentry.init({
  environment: import.meta.env.VITE_ENVIRONMENT,
  dsn: 'https://6b7495979e710f2fc5b94a66f650d42e@o997326.ingest.us.sentry.io/4508576551469056',
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.feedbackIntegration({
      autoInject: false,
      showName: false,
      showEmail: false,
      formTitle: 'Report an Issue',
      messagePlaceholder:
        'Please describe the issue you are experiencing. The more details you provide, the better we can help you.',
      feedbackEmail: 'support@journeyid.com',
      feedbackLabel: 'Report Feedback',
      feedbackSubject: 'Feedback',
      feedbackDescription: 'Please describe the issue you are experiencing.',
      feedbackButtonText: 'Report Feedback',
      feedbackButtonAriaLabel: 'Report Feedback',
      feedbackButtonIcon: '🐛',
      feedbackButtonColor: '#000000',
    }),
  ],
  enabled: import.meta.env.VITE_ENVIRONMENT !== 'development',
  tracesSampleRate: 1.0,
})
